import React from "react";
import {Panel} from "react-bootstrap";
import Component from "../../components/AscComponent";
import SetBreadCrumb from "../Elements/AscElements/SetBreadCrumb";

// 通話モニタリング画面(待ち呼一覧、シートビュー)
export default class CallMonitoring extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            show: false,
        };
    }

    panelOnClick = (path) => {
        this.props.historyPush({
            pathname: path,
        });
    };


    render() {
        const waitStatusesPermission = this.getPermission("WaitStatuses", "CallMonitoring");
        const seatViewPermission = this.getPermission("SeatView", "CallMonitoring");

        const isWaitStatusesVisible = !!(waitStatusesPermission && waitStatusesPermission.read);
        const isSeatViewVisible = !!(seatViewPermission && seatViewPermission.read);
        const hasAnyVisiblePanel = isWaitStatusesVisible || isSeatViewVisible;

        return (
            <React.Fragment>
                <SetBreadCrumb displayItems={[{ name: this.props.langText.Body.CallMonitoring }]} />
                {!hasAnyVisiblePanel && (
                    <div className="no-readable-panels-message text-danger">
                        {this.props.langText.Message.NoVisiblePanelByAuth}
                    </div>
                )}
                <div className="flex-style">
                    {isWaitStatusesVisible &&
                        <Panel
                            bsStyle="info"
                            bsSize="large"
                            className="callmonitoring-select"
                            onClick={() => this.panelOnClick("CallMonitoring/WaitStatuses")}
                        >
                            <Panel.Heading>
                                <Panel.Title componentClass="h1">
                                    {this.props.langText.Body.WaitStatuses}
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body className="body-callmonitoring-select">
                                {this.props.langText.Body.WaitStatusesDescription}
                            </Panel.Body>
                        </Panel>
                    }
                    {isSeatViewVisible &&
                        <Panel
                            bsStyle="info"
                            bsSize="large"
                            className="callmonitoring-select"
                            onClick={() => this.panelOnClick("CallMonitoring/SeatView")}
                        >
                            <Panel.Heading>
                                <Panel.Title componentClass="h1">
                                    {this.props.langText.Body.SeatView}
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body className="body-callmonitoring-select">
                                {this.props.langText.Body.SeatViewDescription}
                            </Panel.Body>
                        </Panel>
                    }
                </div>
            </React.Fragment>
        );
    }
}
